import React, { memo } from "react";
import { Box, Grid } from "@mui/material";
import Amex from "assets/Amex.svg";
import Visa from "assets/Visa.svg";
import Discover from "assets/Discover.svg";
import Mastercard from "assets/Mastercard.svg";
import { TipTitle } from "components/styles";
import TOTips from "components/Payments/TOTips";
import Charges from "components/Charges/Charges";
import PayCash from "components/Payments/PayCash";
import TOCoupon from "components/Payments/TOCoupon";
import TOTipsDriver from "components/Payments/TOTipsDriver";
import TOCashPayment from "components/Payments/TOCashPayment";

// Shared payment methods styles
export const paymentMethodsStyles = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 1,
  mt: 1,
  mb: 1,
};

// Shared payment method icons component
export const PaymentMethodIcons = memo(() => (
  <Box sx={paymentMethodsStyles}>
    <img src={Visa} alt="Payment Visa" />
    <img src={Mastercard} alt="Payment Mastercard" />
    <img src={Discover} alt="Payment Discover" />
    <img src={Amex} alt="Payment Type" />
  </Box>
));

PaymentMethodIcons.displayName = "PaymentMethodIcons";

// Shared tips section component
export const TipsSection = memo(
  ({ showKitchenTips, showDriverTips, bId, oId }) => {
    if (!showKitchenTips && !showDriverTips) return null;

    return (
      <>
        {Boolean(showKitchenTips) && <TOTips bId={bId} oId={oId} />}
        {Boolean(showDriverTips) && <TOTipsDriver bId={bId} oId={oId} />}
      </>
    );
  }
);

TipsSection.displayName = "TipsSection";

// Shared cash payment section component
export const CashPaymentSection = memo(
  ({
    showDriverContent,
    loadingPay,
    handleCashSubmit,
    oId,
    showCashPayment,
  }) => {
    if (!showDriverContent) return null;

    return (
      <>
        <Grid item xs={12}>
          <PayCash />
        </Grid>
        <Grid item xs={12}>
          <TOCashPayment
            loadingPay={loadingPay}
            handleCashSubmit={handleCashSubmit}
            oId={oId}
            showCashPayment={showCashPayment}
          />
        </Grid>
      </>
    );
  }
);

CashPaymentSection.displayName = "CashPaymentSection";

// Shared header section component
export const PaymentHeaderSection = memo(
  ({ isWebView, bId, oId, showKitchenTips, showDriverTips }) => {
    if (isWebView) return null;

    return (
      <>
        <TipsSection
          showKitchenTips={showKitchenTips}
          showDriverTips={showDriverTips}
          bId={bId}
          oId={oId}
        />
        <TOCoupon bId={bId} oId={oId} />
        <Charges />
      </>
    );
  }
);

PaymentHeaderSection.displayName = "PaymentHeaderSection";

// Shared payment type header component
export const PaymentTypeHeader = memo(({ isWebView }) => {
  if (isWebView) return null;

  return (
    <Grid item xs={12}>
      <TipTitle>Payment Type</TipTitle>
    </Grid>
  );
});

PaymentTypeHeader.displayName = "PaymentTypeHeader";

// Shared common visibility conditions hook
export const useCommonVisibilityConditions = (
  loaded,
  error,
  isDriver,
  tipInfoSettings,
  orderType
) => {
  return React.useMemo(
    () => ({
      showCashPayment:
        loaded &&
        !error &&
        isDriver &&
        tipInfoSettings?.driver?.enabled &&
        tipInfoSettings.driver.visibleForDriver,

      showKitchenTips: Boolean(
        (isDriver && tipInfoSettings.kitchen.visibleForDriver) ||
          (!isDriver && tipInfoSettings.kitchen.enabled),
      ),

      showDriverTips: Boolean(
        ((isDriver && tipInfoSettings?.driver?.visibleForDriver) ||
          (!isDriver && tipInfoSettings?.driver?.enabled)) &&
          orderType?.includes("delivery"),
      ),

      showDriverContent: !error && isDriver,

      showCardPayment: !error,
    }),
    [loaded, error, isDriver, tipInfoSettings]
  );
};

// Shared common handlers hook
export const useCommonHandlers = (
  handleSubmit,
  handleCashSubmit,
  setErrorCard,
  setHasTokenForward
) => {
  return React.useMemo(
    () => ({
      handleSubmit,
      handleCashSubmit,
      setErrorCard,
      setHasTokenForward,
    }),
    [handleSubmit, handleCashSubmit, setErrorCard, setHasTokenForward]
  );
};
